import { StateCreator } from 'zustand';

import { IUiStore } from './types';

export const uiSlice: StateCreator<IUiStore, [], [], IUiStore> = (set) => ({
  isInfoScreenOpen: false,
  setIsInfoScreenOpen: (isInfoScreenOpen) => set({ isInfoScreenOpen }),
  infoScreen: null,
  setInfoScreen: (infoScreen) => set({ infoScreen }),
});
